import NavBarMUI from './components/NavBarMUI';
import Banner from './components/Banner';
import './App.css'
import Projects from './components/Projects';
import Contact from './components/Contact';
import FooterMUI from './components/FooterMUI';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
     <ToastContainer position='bottom-center' limit={1} />
      <NavBarMUI />
      <Banner />
      <Projects />
      <Contact />
      <FooterMUI />
    </>
  );
}

export default App;